import { render, staticRenderFns } from "./ResetPasswordStep1.vue?vue&type=template&id=3e86c217"
import script from "./ResetPasswordStep1.vue?vue&type=script&lang=js"
export * from "./ResetPasswordStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports